<script>
import { mapActions, mapState } from "vuex";
import API from "@/api";

import actionCable from "@/utils/actionCable";
import support from "@/utils/support";

import EmailNotVerifiedDialog from "@/components/_Shared/Warnings/EmailNotVerified/Dialog";
import Navbar from "./Navbar/Index";
import Footer from "./Footer";

export default {
  components: {
    Navbar,
    Footer,
    EmailNotVerifiedDialog
  },

  data() {
    return {
      logoutTimeout: null,
      shouldLogout: false
    };
  },

  computed: {
    ...mapState("user", ["user"])
  },

  methods: {
    ...mapActions("user", ["getUser", "logout"]),
    ...mapActions("toast", ["setErrorToast"]),

    initializeCable() {
      this.$cable._cable.url = actionCable.buildURL();
      this.$cable.subscribe({ channel: "AccountChannel" });
    },

    initializeSupport() {
      support.initializeSession(this.user);
    },

    async healthCheck() {
      try {
        await API.Authentication.checkToken();
      } catch (e) {
        if (e.message !== "Network Error") {
          return false;
        }
      }

      return true;
    }
  },

  channels: {
    AccountChannel: {
      connected() {
        this.shouldLogout = false;
        clearTimeout(this.logoutTimeout);
        this.logoutTimeout = null;
      },

      disconnected() {
        if (this.healthCheck()) {
          return;
        }

        if (this.shouldLogout && this.logoutTimeout) {
          return;
        }

        this.shouldLogout = true;

        this.logoutTimeout = setTimeout(() => {
          if (this.shouldLogout) {
            this.setErrorToast(
              "A sua sessão expirou. Você será redirecionado para a tela de login."
            );

            setTimeout(() => {
              this.logout();
              document.location.reload(true);
            }, 5000);
          }
        }, 40000);
      },

      received(data) {
        this.getUser(this.user.id);
      }
    }
  },

  mounted() {
    this.initializeCable();

    this.initializeSupport();
  }
};
</script>


<template>
  <div class="wrapper">
    <navbar v-if="!$route.path.includes('checkout/mobile/pedidos') && !$route.path.includes('checkout/mobile/assinaturas')" />

    <div class="content-wrapper">
      <email-not-verified-dialog />

      <keep-alive>
        <transition name="zoom" mode="out-in">
          <router-view />
        </transition>
      </keep-alive>
    </div>

    <Footer v-if="!$route.path.includes('checkout/mobile/pedidos') && !$route.path.includes('checkout/mobile/assinaturas')" />
  </div>
</template>

<style scoped>
.wrapper {
  position: absolute;
  width: 100%;
  min-height: 100%;
  background-color: #f4f4f4;
}
.content-wrapper {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 240px);
  padding: 50px 0 25px 0;
}

@media (max-width: 992px) {
  .content-wrapper {
    min-height: calc(100vh - 150px);
    padding: 10px 0 25px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Wrapper.vue